import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import Portfolio from '@/views/Portfolio'
import PortfolioDetailed from '@/views/PortfolioDetailed'
import Services from '@/views/Services'
import Catalog from '@/views/Catalog'
import cabBuilder from '@/views/CabBuilder'
import OurClients from '@/views/OurClients'
import Finishes from '@/views/Finishes'
import ContactUs from '@/views/ContactUs'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  //base: 'USC-Elevator',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about-us',
      name: 'about',
      component: About
    },
    {
      path: '/portfolio',
      name: 'portfolio',
      component: Portfolio
    },
    {
      path: '/portfolio/:id',
      name: 'portfolio',
      component: PortfolioDetailed
    },
    {
      path: '/catalog/',
      name: 'catalog',
      component: Catalog
    },
    {
      path: '/catalog/:id',
      name: 'catalogItem',
      props: true,
      component: Catalog
    },
    {
      path: '/cab-builder/',
      name: 'cabBuilder',
      component: cabBuilder
    },
    {
      path: '/cab-builder/:id',
      name: 'cabBuilderItem',
      props: true,
      component: cabBuilder
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/our-clients',
      name: 'OurClients',
      component: OurClients
    },
    {
      path: '/finishes',
      name: 'Finishes',
      component: Finishes
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: ContactUs
    }
  ]
})
router.beforeEach(function (to, from, next) {
  if( (to.name != 'catalogItem' && to.name != 'cabBuilderItem') && (from.name != 'catalogItem' && from.name != 'cabBuilderItem') )
  {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
  }
  next();
});
export default router


// WEBPACK FOOTER //
// ./src/router/index.js